import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Switcher from "./toggleDarkMode";
import scrollTo from "./ScrollTo";

// Small screen x Mobile menu
function menuToggle(setIsMenuOpen) {
  const navContent = document.getElementById("nav-content");
  navContent.classList.toggle("translate-x-full");
  navContent.classList.toggle("translate-x-0");
  setIsMenuOpen((prev) => !prev);
}

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    // Close menu when clicking outside
    const handleClickOutside = (event) => {
      const navContent = document.getElementById("nav-content");
      const navToggle = document.getElementById("nav-toggle");
      if (
        navContent &&
        navContent.classList.contains("translate-x-0") &&
        !navContent.contains(event.target) &&
        !navToggle.contains(event.target)
      ) {
        menuToggle(setIsMenuOpen);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleMenuItemClick = (callback) => {
    if (window.innerWidth < 768) {
      menuToggle(setIsMenuOpen);
    }
    callback();
  };

  return (
    <nav className="flex items-center relative h-9 justify-between text-black dark:bg-[#201c1c] z-50 mb-4 w-full">
      <Link
        to="/"
        aria-label="Go to the homepage"
        className="text-2xl p-2 mt-7 md:text-4xl dark:text-white font-poppinsFont font-semibold w-auto ml-0 cursor-pointer hover:text-emerald-500 transition-colors duration-300"
      >
        IS
      </Link>
      <div className="block md:hidden w-full absolute z-50 mt-5">
        <button
          id="nav-toggle"
          aria-controls="nav-content"
          aria-expanded={isMenuOpen}
          onClick={() => menuToggle(setIsMenuOpen)}
          className="flex items-center float-right mt-2 mr-4 text-gray-700 dark:text-white"
        >
          <svg
            className="fill-current h-5 w-5"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <title>Menu</title>
            <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
          </svg>
        </button>
      </div>
      {isMenuOpen && (
        <div className="fixed top-0 left-0 w-full h-full bg-black opacity-60 z-30" />
      )}
      <div
        className="fixed top-0 right-0 h-full dark:bg-[#201c1c] transform translate-x-full transition-transform duration-300 ease-in-out z-40 md:translate-x-0 md:relative md:w-auto md:flex lg:mr-8 py-8 sm:py-4"
        id="nav-content"
      >
        <div className="flex w-full">
          <ul className="md:flex p-4 font-poppinsFont text-white md:text-black dark:md:text-[#e4e4e4] text-lg md:text-base gap-6 md:gap-8 md:space-y-0 space-y-3 items-center">
            <li
              className="nav-link group cursor-pointer"
              onClick={() => handleMenuItemClick(() => scrollTo("#projects"))}
            >
              <a
                title="View my portrait photography"
                href="/portraits"
                className="relative inline-block px-1 py-2 font-medium transition-colors duration-300 hover:text-emerald-500 after:content-[''] after:absolute after:bottom-0 after:left-0 after:w-0 after:h-0.5 after:bg-emerald-500 after:transition-all after:duration-300 group-hover:after:w-full"
              >
                Portraits
              </a>
            </li>
            <li
              className="nav-link group cursor-pointer"
              onClick={() => handleMenuItemClick(() => scrollTo("#projects"))}
            >
              <a
                title="View my landscapes and interior photography"
                href="/landscapes"
                className="relative inline-block px-1 py-2 font-medium transition-colors duration-300 hover:text-emerald-500 after:content-[''] after:absolute after:bottom-0 after:left-0 after:w-0 after:h-0.5 after:bg-emerald-500 after:transition-all after:duration-300 group-hover:after:w-full"
              >
                Landscapes + Interiors
              </a>
            </li>
            <li
              className="nav-link group cursor-pointer"
              onClick={() => handleMenuItemClick(() => scrollTo("#projects"))}
            >
              <a
                title="View my candid & street photography"
                href="/moments"
                className="relative inline-block px-1 py-2 font-medium transition-colors duration-300 hover:text-emerald-500 after:content-[''] after:absolute after:bottom-0 after:left-0 after:w-0 after:h-0.5 after:bg-emerald-500 after:transition-all after:duration-300 group-hover:after:w-full"
              >
                Moments
              </a>
            </li>
            {/* <li
              className="nav-link group cursor-pointer"
              onClick={() => handleMenuItemClick(() => scrollTo("#about"))}
            >
              <a
                href="/photography/about"
                className="border-none bg-transparent cursor-pointer"
              >
                About
              </a>
            </li> */}
            <li
              className="nav-link group cursor-pointer"
              onClick={() => handleMenuItemClick(() => scrollTo("#contact"))}
            >
              <a
                title="Contact me about with any photography inquiries or projects"
                href="/contact"
                className="relative inline-block px-1 py-2 font-medium transition-colors duration-300 hover:text-emerald-500 after:content-[''] after:absolute after:bottom-0 after:left-0 after:w-0 after:h-0.5 after:bg-emerald-500 after:transition-all after:duration-300 group-hover:after:w-full"
              >
                Contact
              </a>
            </li>
            <li
              className="flex items-center md:ml-2 opacity-80 hover:opacity-100 transition-opacity duration-300"
              title="Toggle dark/light mode"
            >
              <Switcher />
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
export default Header;
